import { reportDiscountsRelationshipTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_DISCOUNTS_RELATIONSHIP_FILTERS,
  RESTORE_INITIAL
} = reportDiscountsRelationshipTypes;

const initialState = {
  data: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportDiscountsRelationshipReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DISCOUNTS_RELATIONSHIP_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
